/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetWorkspaceRequest = {
  sessionId: string;
  sessionToken?: string | null | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetWorkspaceRequest$inboundSchema: z.ZodType<
  GetWorkspaceRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  session_token: z.nullable(z.string()).optional(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "session_token": "sessionToken",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetWorkspaceRequest$Outbound = {
  session_id: string;
  session_token?: string | null | undefined;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetWorkspaceRequest$outboundSchema: z.ZodType<
  GetWorkspaceRequest$Outbound,
  z.ZodTypeDef,
  GetWorkspaceRequest
> = z.object({
  sessionId: z.string(),
  sessionToken: z.nullable(z.string()).optional(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    sessionToken: "session_token",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getWorkspaceRequestToJSON(
  getWorkspaceRequest: GetWorkspaceRequest,
): string {
  return JSON.stringify(
    GetWorkspaceRequest$outboundSchema.parse(getWorkspaceRequest),
  );
}
export function getWorkspaceRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetWorkspaceRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetWorkspaceRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetWorkspaceRequest' from JSON`,
  );
}
